export default __webpack_public_path__ + "static/media/globe.2a52cd4c.png";